export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.workplace': 'Workplace',
  'menu.monitor-alert': 'Monitoring & Alerts',
  'menu.monitor-alert.monitor': 'Live Monitor',
  'menu.monitor-alert.warning-info': 'Warnings',
  'menu.monitor-alert.push-config': 'Push Config',
  'menu.algorithm-center': 'Algorithm Center',
  'menu.algorithm-center.algorithm-market': 'Algorithm Market',
  'menu.algorithm-center.my-algorithm': 'My Algorithms',
  'menu.algorithm-center.algo-self-train': 'Self Training',
  'menu.algorithm-center.algo-self-train-review': 'Review Samples',
  'menu.algorithm-center.custom-train': 'Custom Model Training',
  'menu.algorithm-center.custom-train-create': 'Create Training',
  'menu.algorithm-center.custom-train-create-resume': 'Resume Training',
  'menu.algorithm-center.custom-train-annotate': 'Annotate',
  'menu.open-legacy-settings': 'Open Platform Settings',
  'menu.fee-center': 'Billing',
  'menu.fee-center.my-compute': 'My Packages',
  'menu.fee-center.my-compute.cloud': 'Cloud Package',
  'menu.fee-center.my-compute.local': 'Local Package',
  'menu.fee-center.quota-purchase': 'Quota Purchase',
  'menu.fee-center.quota-purchase.local': 'Local Quota Purchase',
  'menu.fee-center.quota-purchase.cloud': 'Cloud Quota Purchase',
  'menu.fee-center.balance-recharge': 'Balance & Recharge',
  'menu.fee-center.bill-center': 'Billing Center',
  'menu.monitor': 'Live Monitor',
  'menu.warning-info': 'Warnings',
  'menu.push-config': 'Push Config',
  'menu.algorithm-market': 'Algorithm Market',
  'menu.my-algorithm': 'My Algorithms',
  'menu.algo-self-train': 'Self Training',
  'menu.algo-self-train-review': 'Review Samples',
  'menu.custom-train': 'Custom Model Training',
  'menu.custom-train-create': 'Create Training',
  'menu.custom-train-annotate': 'Annotate',
  'menu.quota-purchase': 'Quota Purchase',
  'menu.quota-purchase.local': 'Local Quota Purchase',
  'menu.quota-purchase.cloud': 'Cloud Quota Purchase',
  'menu.my-compute': 'My Packages',
  'menu.my-compute.cloud': 'Cloud Package',
  'menu.my-compute.local': 'Local Package',
  'menu.bill-center': 'Billing Center',
  'menu.balance-recharge': 'Balance & Recharge',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
